<template>
    <div id="preloader" class="loader-overlay" :style="{'display': show ? 'block' : 'none'}">
       <div id="status">
         <div class="spinner">
           <i class="ri-loader-line spin-icon"></i>
         </div>
       </div>
     </div>
 </template>
 <script>
    
export default {
	props: ["show"]
}
</script>

 <style scoped>
#preloader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(141 137 137 / 70%);
    z-index: 9999;
}

#status {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateY(-50%);
    margin: -20px 0 0 -20px;
}

.spinner
    .spin-icon {
        font-size: 56px;
        color: blue;
        position: relative;
        display: inline-block;
        animation: spin 1.6s infinite linear;
    }


@keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
}
  
 </style>